<template>
  <b-col sm="12" lg="12">
    <div class="animated fadeIn">
      <b-card>
        <div v-if="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h4 class="card-title">All locations</h4>
          <b-form-input
            class="search-input"
            v-model="searchQuery"
            type="search"
            placeholder="Type to Search"
          ></b-form-input>
          <hr />
          <b-row>
            <template>
              <b-col
                lg="3"
                sm="6"
                v-for="location in filterItems(locationData)"
                :key="location.id"
                class="list-item"
              >
                <a
                  :href="
                    '#/base/city/?loc=' +
                    location.id +
                    '&city=' +
                    location.locaton +
                    '&lat=' +
                    location.lat +
                    '&lng=' +
                    location.lng
                  "
                  >{{ location.locaton }}</a
                >
              </b-col>
            </template>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "ProfileLocations",
  components: {},
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loading: true,
      locations: [],
    };
  },
  methods: {
    // fetchLocations() {
    //   this.$http.get("api/" + this.$company  + "/profile/alphaLocations.php", {}).then(
    //     res => {
    //       console.log(res.data);
    //       this.locations = res.data.records;
    //       this.loading = false;
    //     },
    //     err => {
    //       console.log(err);
    //       this.loading = false;
    //     }
    //   );
    // },
    filterItems: function (locations) {
      var app = this;
      return locations.filter(function (location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    },
  },
  mounted() {
    // this.fetchLocations();
    this.loading = false;
  },
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
.card-title {
  display: inline-block;
}
.search-input {
  width: 250px;
  float: right;
}
.list-item {
  padding: 5px;
}
</style>
